import { render, staticRenderFns } from "./BaseMetricStrip.vue?vue&type=template&id=c1995e02&scoped=true"
import script from "./BaseMetricStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMetricStrip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseMetricStrip.vue?vue&type=style&index=0&id=c1995e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1995e02",
  null
  
)

export default component.exports